export const currencyFormat = num => {
  if (!num) return num;
  return (
    num
      .toFixed(2) // always two decimal digits
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €'
  );
};

export const dotFormat = num => {
  if (!num) return num;
  return num
    .toFixed(2) // always two decimal digits
    .replace(',', '.');
};
